export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pl": {
        "You have selected:": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybrano:"])},
        "New Search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nowe Wyszukiwanie"])},
        "Copied URL to Clipboard! ": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Skopiowano adres URL do schowka: "])}
      }
    }
  })
}
